import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/app/layouts/default.vue").then(m => m.default || m))
}